export const STUDENT_NOTE_DELETE_WINDOW_MS = 24 * 60 * 60 * 1000;

export function isStudentNoteWithinDeleteWindow(
  createdAt: string,
  now = Date.now(),
): boolean {
  const createdAtMs = Date.parse(createdAt);
  if (!Number.isFinite(createdAtMs)) {
    return false;
  }

  return now - createdAtMs < STUDENT_NOTE_DELETE_WINDOW_MS;
}

export function canDeleteStudentNote(
  note: { can_delete: boolean; created_at: string },
  now = Date.now(),
): boolean {
  return note.can_delete && isStudentNoteWithinDeleteWindow(note.created_at, now);
}
